import _Promise from 'babel-runtime/core-js/promise';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import SearchBar from '@/components/SearchV3/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import previewModal from '@/components/PreviewModal';
import ViewDialog from './dialog.vue';
import { fetchAdvertiserList } from '@/api/advertiser/manage';
import { getPSProjectList,
// exportPSProjectExcel,
getPSProjectPreview } from '@/api/ps/manage';
import { loginAdvertiser } from '@/api/advertiser/manage';
import _ from 'lodash';
import { playTurboHostList } from '@/config/host';
import { NODE_ENV } from '@com/config/env';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { currencyList, isPrePayList } from '@/views/advertiser/utils';
import { fmtTime } from '@com/utils/data-format';
import { v2Host } from '@/config/host';
import qs from 'qs';
import { downloadWithNewWindow } from '@/common/download.js';
import { cookRequestParams } from '@/common/request.js';

export default {
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList,
    previewModal: previewModal,
    // ExportXlsx
    ViewDialog: ViewDialog
  },
  mixins: [searchMixin],
  data: function data() {
    var keyFieldConfig = [{
      value: 'adv_id',
      label: '广告主ID'
    }, {
      value: 'adv_name',
      label: '广告主名称'
    }, {
      value: 'name',
      label: '项目名称'
    }, {
      value: 'id',
      label: '项目ID'
    }];

    var statusConfig = [{
      value: 1,
      label: '是'
    }, {
      value: 2,
      label: '否'
    }];

    return {
      query: {
        page: 1,
        page_size: 15,
        search_field: 'adv_name',
        keyword: '',
        country: '',
        timezone: '',
        setting_final_review: '',
        setting_down_file: '',
        email: '',
        currency: '',
        cooperation_entity: '',
        advance: '',
        bd_id: '',
        bd_am_id: ''
      },
      pagination: {
        total: 0
      },
      sheetBody: [],
      listLoading: true,
      keyFieldConfig: keyFieldConfig,
      statusConfig: statusConfig,
      timeZoneList: [],
      countryList: [],
      list: [],
      formConfig: {
        labelPosition: 'left',
        labelWidth: '100px'
      },

      advertiserOptions: [],
      currentAdvertiser: {},
      loadingList: [],
      previewDialog: {
        visible: false,
        title: '',
        html_url: '',
        cn_html_url: '',
        showCnUrl: false,
        id: ''
      },
      viewDialog: {
        visible: false,
        params: {}
      }
    };
  },

  computed: {
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: '项目Id',
        prop: 'id',
        width: 100
      }, {
        label: '项目名称',
        prop: 'name'
      }, {
        label: '广告主Id',
        prop: 'adv_id',
        width: 100
      }, {
        label: '广告主名称',
        prop: 'adv_name'
      }, {
        label: 'icon',
        width: 130,
        prop: 'thumbnail',
        type: 'image',
        slot: 'icon',
        params: {
          preview: true
        }
      }, {
        label: '产品信息',
        prop: 'push_msg',
        slot: 'push_msg'
      }, {
        label: 'app tag',
        prop: 'app_tag',
        slot: 'app_tag'
      }, {
        label: 'project tag',
        prop: 'project_tag',
        slot: 'project_tag'
      }, {
        label: '创建时间',
        prop: 'created_time',
        type: 'date'
      }, {
        label: '更新时间',
        prop: 'updated_time',
        type: 'date'
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }];
    },
    sheetHeader: function sheetHeader() {
      var headers = {};
      this.tableColumnConfig.forEach(function (item) {
        if (item.prop) headers[item.prop] = item.label;
      });
      return _extends({}, headers);
    },
    formItemList: function formItemList() {
      var _this = this;

      return [{
        prop: 'search_field',
        type: 'select',
        params: {
          clearable: false,
          filterable: true,
          style: 'width: 220px;',
          options: this.keyFieldConfig,
          placeholder: '请选择搜索类型'
        }
      }, {
        prop: 'keyword',
        type: 'input',
        params: function params(_ref) {
          var formValue = _ref.formValue;

          return {
            disabled: false,
            readonly: false,
            clearable: true,
            style: 'width: 220px;',
            placeholder: formValue.search_field ? '按' + _this.keyFieldConfig.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入关键字'
          };
        }
      }];
    },
    playTurboUrl: function playTurboUrl() {
      return playTurboHostList[NODE_ENV] + '/#/auth';
    }
  },

  watch: {
    $route: function $route() {
      this.renderList();
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.getDependencyData();

            case 2:
              _context.next = 4;
              return _this2.renderList();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },


  methods: {
    renderList: function renderList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.listLoading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return getPSProjectList(_this3.query);

              case 4:
                res = _context2.sent;

                _this3.list = (_.get(res, 'data.data.list') || []).map(function (advertiser) {
                  return _this3.cookAdvertiser(advertiser);
                });
                _this3.pagination.total = _.get(res, 'data.data.total');
                _this3.listLoading = false;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](1);

                _this3.listLoading = false;

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 10]]);
      }))();
    },
    request: function request(params) {
      return fetchAdvertiserList(_extends({}, this.query, params));
    },
    previewPA: function previewPA(obj) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.loadingList.push(obj.id);
                _context3.next = 3;
                return getPSProjectPreview({
                  id: obj.id
                });

              case 3:
                res = _context3.sent;

                _this4.loadingList = _this4.loadingList.filter(function (val) {
                  return val !== obj.id;
                });
                if (_.get(res, 'data.code') === 0) {
                  _this4.previewDialog.visible = true;
                  _this4.previewDialog.title = obj.name;
                  _this4.previewDialog.html_url = _.get(res, 'data.data.preview_url');
                } else {
                  _this4.$message.error(_.get(res, 'data.msg'));
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    cookAdvertiser: function cookAdvertiser(advertiser) {
      var temp = _extends({}, advertiser, {
        currency: useValueExchangeLabel(advertiser.currency, currencyList) || '-',
        advance: useValueExchangeLabel(advertiser.advance, isPrePayList) || '-',
        timezone: this.formatTimeZone(advertiser),
        bd: useValueExchangeLabel(advertiser.bd_id, this.advertiserOptions.bd || []) || '-',
        bd_am: useValueExchangeLabel(advertiser.bd_am_id, this.advertiserOptions.bd_am || []) || '-',
        cooperation_entity_label: useValueExchangeLabel(advertiser.cooperation_entity, (this.advertiserOptions.adv_cooperation_entity || []).filter(function (item) {
          return item.currency === advertiser.currency;
        })) || '-',
        updated_time: fmtTime(advertiser.updated_time),
        created_time: fmtTime(advertiser.created_time)
        // thumbnail: advertiser.
      });
      return temp;
    },
    cookSheetList: function cookSheetList(res) {
      var _this5 = this;

      var list = (_.get(res, 'data.data.list') || []).map(function (advertiser) {
        var temp = _this5.cookAdvertiser(advertiser);
        return temp;
      });
      return list;
    },
    formatTimeZone: function formatTimeZone(_ref2) {
      var timezone = _ref2.timezone;

      var item = this.timeZoneList.find(function (item) {
        return Number(item.value) === Number(timezone);
      });
      if (item) {
        return item.label.split('(')[0];
      }
      return '-';
    },
    login: function login(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var newTab, close, res, token;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                newTab = window.open('about:blank');

                close = function close() {
                  if (newTab) {
                    newTab.close();
                    newTab = null;
                  }
                };

                _context4.prev = 2;
                _context4.next = 5;
                return loginAdvertiser({
                  id: row.id
                });

              case 5:
                res = _context4.sent;

                if (res.data.code === 0) {
                  token = _.get(res, 'data.data.token') || '';

                  newTab.location.href = _this6.playTurboUrl + '?token=' + token;
                  newTab = null;
                } else {
                  close();
                }
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](2);

                close();

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[2, 9]]);
      }))();
    },
    openAdvertiserDialog: function openAdvertiserDialog() {
      this.$store.dispatch('advertiser/openDialog');
      this.$store.dispatch('advertiser/resetInfo');
    },
    openEditAdvertiserDialog: function openEditAdvertiserDialog(data) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this7.$store.dispatch('advertiser/openDialog', {
                  type: 'edit',
                  id: data.id
                });

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    getDependencyData: function getDependencyData() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _ref3, _ref4, _ref4$, advertiserOptions, _ref4$2, countryList, _ref4$3, timeZoneList;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _Promise.all([_this8.$store.dispatch('advertiser/getOptions'), _this8.$store.dispatch('config/getCountryList'), _this8.$store.dispatch('config/getTimeZoneList')]);

              case 2:
                _ref3 = _context6.sent;
                _ref4 = _slicedToArray(_ref3, 3);
                _ref4$ = _ref4[0];
                advertiserOptions = _ref4$ === undefined ? {} : _ref4$;
                _ref4$2 = _ref4[1];
                countryList = _ref4$2 === undefined ? [] : _ref4$2;
                _ref4$3 = _ref4[2];
                timeZoneList = _ref4$3 === undefined ? [] : _ref4$3;

                _this8.advertiserOptions = advertiserOptions;
                _this8.countryList = countryList;
                _this8.timeZoneList = timeZoneList;

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    handleSaveSuccess: function handleSaveSuccess() {
      this.renderList();
    },
    handleCommand: function handleCommand(command) {
      var path = '/project/export-basic';
      var data = {
        id: String(command.params.row.id),
        quality: command.quality
      };
      var downloadUrl = v2Host + '/ps' + path + '?' + qs.stringify(data);
      window.open(downloadUrl, '_blank');
    },
    exportProjectList: function exportProjectList() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var params, query;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                params = {
                  page: _this9.query.page,
                  page_size: _this9.query.page_size,
                  search_field: _this9.query.search_field,
                  keyword: _this9.query.keyword
                  // const res = await exportPSProjectExcel(params)
                  // const url = `${res.config.url}?page=${this.query.page}&page_size=${this.query.page_size}&search_field=${this.query.search_field}&keyword=${this.query.keyword}`
                  // window.open(url, '_blank')
                };
                query = cookRequestParams(params);

                downloadWithNewWindow(v2Host + '/ps/project/export?' + qs.stringify(query));

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },
    viewProject: function viewProject(row) {
      this.viewDialog.params = {
        copy_project_id: row.id,
        name: row.name,
        orientation: row.orientation,
        type: 'view'
      };
      this.viewDialog.visible = true;
    }
  }
};